export default {
  noResults: "No se encontraron registros.",
  filter: "Filtrar:",
  filterBy: "Filtrar por {column}",
  count: " ",
  filterPlaceholder: "Buscar...",
  columns: "Columnas",
  loading: "Cargando...",
  defaultOption: "Seleccione {column}",
  limit: "Registros:"
};
